import axios from 'axios';

const axiosClient = axios.create();

export function download(downloadUrl: string, filename: string) {
  axiosClient
    .get(downloadUrl, {
      responseType: 'blob'
    })
    .then((res) => {
      const url = window.URL.createObjectURL(res.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    });
}
